<app-widget-card-wrapper title="Maramataka Phase" [hide]="false">
  <div class="card-stretch text-center">
    <app-energy-phases-charts [toDate]="toDate" [timeScale]="timeScale"></app-energy-phases-charts>
  </div>
</app-widget-card-wrapper>
